<template>
  <div v-if="column">
    <h3>{{ column.Name }}</h3>
    <b-card>
      <b-row>
        <b-col>
          <label>Sortering:</label>
        </b-col>
        <b-col>
          <b-form-group>
            <b-form-radio v-model="column.OrderBy" name="some-radios" value
              >(ingen)</b-form-radio
            >
            <b-form-radio
              v-model="column.OrderBy"
              name="some-radios"
              value="asc"
              >Stigande</b-form-radio
            >
            <b-form-radio
              v-model="column.OrderBy"
              name="some-radios"
              value="desc"
              >Fallande</b-form-radio
            >
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="column">
      <b-card-header>Filter:</b-card-header>
      <b-card-body>
        <qvcond :fields="[column]" :cond="cond" :hidefield="true"  @change="setChange()"></qvcond>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import datepicker from "../../components/datepicker";
import qvcond from "./queryviewcondition";
import { qvCondition } from "../../lib/qvcondition.js";

const cndLib = new qvCondition();

import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "queryviewfilter",
  components: { datepicker, qvcond },
  props: {
    column: Object,
  },
  created() {
    this.getData();
    //
  },
  data() {
    return {
      distincts: [],
      searchfor: null,
      dateMin: null,
      dateMax: null,
      numMin: null,
      numMax: null,
      cond: { field: null, type: null, min: null, max: null, eq: null },
    };
  },
  methods: {    
    getData(onReady) {
      api.get('/api/apiqueryview/GetQueryViewColumn?id=' + this.column.id)
      .then((res) => {
        console.log('OK. Got it');
        if(res.data) {
          var f = res.data.Filter;
          if (f && f.startsWith("{")) {            
            this.column.Filter = f;
            var flt = JSON.parse(this.column.Filter);
            this.cond = flt;
                        
            if (flt.exact && flt.exact.length > 0)
              this.distincts.map((x) => {
                x.chk = flt.exact.indexOf(x.Value) >= 0;
              });
          } else {
            //Create new filter
            if(this.column)
              this.cond = {field: this.column.ColumnName };
          }
          this.column.Filter = res.data.Filter;
          var flt = JSON.parse(res.data.Filter);

        }
      });
      api
        .get(
          "/api/apiqueryview/GetDistincts?" +
            api.params({ id: this.column.id, filter: this.searchfor })
        )
        .then((res) => {
          this.distincts = res.data;
          this.distincts.forEach((x) => (x.chk = false)); //TODO: This could be checked from server side?
          if (this.column.Filter && this.column.Filter.startsWith("{")) {            
            var flt = JSON.parse(this.column.Filter);
            this.cond = flt;
                        
            if (flt.exact && flt.exact.length > 0)
              this.distincts.map((x) => {
                x.chk = flt.exact.indexOf(x.Value) >= 0;
              });
          } else {
            //Create new filter
            if(this.column)
              this.cond = {field: this.column.ColumnName };
          }
          if (onReady) onReady();
        });
    },
    getFilteredDistincts(flt, distincts) {
      if (!flt || flt == "" || !distincts) return distincts;

      var v = flt.toLowerCase();
      return distincts.filter((x) => x.Value.toLowerCase().indexOf(v) >= 0);
    },
    setColumn() {
      var api = new Api();
      api
        .post("/QueryView/QueryViewColumn/" + this.column.id)
        .then((res) => {
          this.distincts = res.data;
        });
    },
    setChange() {
      // var res = {};
      // var tp = this.GetColType(this.column);
      // if (tp == "date") {
      //   if (this.dateMin) res.min = this.dateMin;
      //   if (this.dateMax) res.max = this.dateMax;
      // }
      // if (this.numMin) res.min = this.numMin;
      // if (this.numMax) res.max = this.numMax;

      // if (tp == "text") {
      //   var exact = this.distincts.filter((x) => x.chk);
      //   if (exact.length > 0) res.exact = exact.map((x) => x.Value);
      // }    
      // this.$emit("change", res);
      var res = this.cond;
      if(!cndLib.IsFiltering(this.cond))
        res = {};

      this.$emit("change", res);
    },
    removeFilter() {
      this.$emit("change", {});
    },
    reselect() {
      this.getData(function () {
        if (this.searchfor != null) {
          var v = this.searchfor.toLowerCase();
          if (v != "")
            this.distincts.map(
              (x) => (x.chk = x.Value.toLowerCase().indexOf(v) >= 0)
            );
          this.setChange();
        }
      });
    },
    toggleSelected() {
      var sels = this.getFilteredDistincts(this.searchfor, this.distincts);
      if (sels.length > 0) {
        var v = !sels[0].chk;
        sels.forEach((x) => (x.chk = v));
        this.setChange();
        this.$forceUpdate();
      }
    },
    //TODO: Move to common lib
    GetColType(c) {
      var ct = c.ColumnType.toLowerCase();
      if (ct.indexOf("date") >= 0) return "date";
      if (ct.indexOf("char") >= 0) return "text";
      if (
        ct.indexOf("int") >= 0 ||
        ct.indexOf("bigint") ||
        ct.indexOf("decimal") ||
        ct.indexOf("numeric")
      )
        return "numeric";
      if(ct.indexOf("bit"))
        return "bit";
    },    
  },
};
</script>
<style scoped>
.scroll {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>